export default __webpack_public_path__ + "images/Transcerebellar_View.5bee5b195fba1c53b22c03df9219374c.png";